import { getPrintableCorporationType } from '@commenda/utils';
import { Handle, NodeProps, Position } from '@xyflow/react';
import { memo } from 'react';
import { EntityDetailsPopover } from '../../common/EntityDetailsPopover';
import type { EntityNode as EntityNodeType } from '../graph/types';
import { EntityPill } from './EntityPill';

const EntityNode = memo(({ data }: NodeProps<EntityNodeType>) => {
  const typeLabel =
    data.businessEntityType && data.incorporationCountry
      ? getPrintableCorporationType(
          data.businessEntityType,
          data.incorporationCountry
        )
      : null;

  return (
    <EntityDetailsPopover
      entity={data}
      typeLabel={typeLabel}
      fallbackName={
        data.incorporationCountry
          ? `New ${data.incorporationCountry} Entity`
          : ''
      }
    >
      <EntityPill
        legalName={data.legalName}
        incorporationCountry={data.incorporationCountry}
        businessEntityType={data.businessEntityType}
        disabled={data.isNonControlledEntity}
      >
        <Handle
          type="target"
          position={Position.Top}
          className="!bg-transparent !border-0 !w-px !h-px !min-w-0 !min-h-0"
        />
        <Handle
          type="source"
          position={Position.Bottom}
          className="!bg-transparent !border-0 !w-px !h-px !min-w-0 !min-h-0"
        />
      </EntityPill>
    </EntityDetailsPopover>
  );
});
EntityNode.displayName = 'EntityNode';

export { EntityNode };
